const isNotEmptyString = (value) => value !== '';

const isDefined = (value) =>
  isNotEmptyString(value) && typeof value !== 'undefined';

export const orZero = (value) => value || 0;

export default isDefined;
